import React, { useEffect } from "react";
import { useFetchRoleReviewsByEmployeeQuery } from "../../../services/roleReviewService";
import useAuth from "../../../hooks/useAuth";
import { Box, styled } from "@mui/system";
import ActivateLogo from "../../../assets/images/activate-logo.svg";
import { useLocation } from "react-router-dom";
import { useFetchVersionNumberQuery } from "../../../services/reportService";

const Firsttable = ({userId }) => {
  const { users } = useAuth();
  const location = useLocation(); // Access location state

  // Extract isJwtUser and userId from location.state
  const isJwtUser = location.state?.isJwtUser || false;
  const userIdFromState = location.state?.userId;
  let employeeId;
 
  
  if (isJwtUser) {
    employeeId = userIdFromState;
    console.log("isJwtUser",employeeId) // Use userId from state for JWT-based users
    // JWT users are treated as employees
  } else if (users?.role === "manager" || users?.role === "superadmin") {
    employeeId = userId; // Use the userId prop for managers and superadmins
    // Set role as manager
  } else {
    employeeId = users?.user_id;
    console.log("Normal",employeeId) // Use the logged-in user's ID for non-managers
    // Use the logged-in user's role
  }
  const { data: versionData} = useFetchVersionNumberQuery(employeeId);
  // let employeeId;
  // // console.log(userId);
  // // console.log(users.role);
  // if (users?.role === "manager") {
  //   employeeId = userId; // Use the userId prop for managers
  // } else {
  //   employeeId = users?.user_id; // Use the logged-in user's ID for non-managers
  // }
  // console.log(userId);
  const { data, isLoading, error,refetch:info_data } =
    useFetchRoleReviewsByEmployeeQuery(employeeId);
    useEffect(() => {
          
          
      if (employeeId) {
        info_data(); // Refetch data if employeeId is set
      }
    }, [employeeId, info_data]);
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error?.message}</div>;

  const formData = data?.data?.[0];
  // console.log(formData);
  if (!formData) {
    return <div>No data available</div>; // Handle case where formData is undefined
  }
  
 
  // Function to format date as 'YYYY-MM-DD'
  // const formatDate = (dateTime) => {
  //   if (!dateTime) return "N/A";
  //   return dateTime.split('T')[0]; // Extract the date part
  // };
  const formatDate = (dateTime) => {
    if (!dateTime) return "N/A";

  
    const date = new Date(dateTime); // Create a Date object
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${month}-${day}-${year}`;

  };
 

  return (
    <UserDetailsMainWrap className="pdf-avoid-break">
      <UserDetailsBox>
        <UserBoxWrap>
          <UserBoxData variant="subtitle1">
            Name: <Box component="span">{formData.name}</Box>
          </UserBoxData>
        </UserBoxWrap>
        <UserBoxWrap>
          <UserBoxData variant="subtitle1">
            Company: <Box component="span">{formData.organization}</Box>
          </UserBoxData>
        </UserBoxWrap>
        <UserBoxWrap>
          <UserBoxData variant="subtitle1">
            Prepared by: <Box component="span">{formData.prepared_by}</Box>
          </UserBoxData>
        </UserBoxWrap>
        <UserBoxWrap>
          <UserBoxData variant="subtitle1">
            Title: <Box component="span">{formData.title}</Box>
          </UserBoxData>
        </UserBoxWrap>
        <UserBoxWrap>
          <UserBoxData variant="subtitle1">
            Department:{" "}
            <Box component="span">{formData.department || "N/A"}</Box>
          </UserBoxData>
        </UserBoxWrap>
        <UserBoxWrap>
          <UserBoxData variant="subtitle1">
            Purpose: <Box component="span">{formData.purpose}</Box>
          </UserBoxData>
        </UserBoxWrap>
        <UserBoxFullWrap>
          <UserBoxData variant="subtitle1">
            Job Summary: <Box component="span">{formData.job_summary}</Box>
          </UserBoxData>
        </UserBoxFullWrap>
      </UserDetailsBox>
      <UserDetailsLogoBox>
        <img
          src={ActivateLogo}
          alt="Activate Logo"
          width="238"
          height="90"
          style={{
            maxWidth: "170px",
            height: "auto",
            display: "block",
            margin: "0 auto 10px",
          }}
        />
        <DateWrap>{formatDate(formData.date)}</DateWrap>
        <DateWrap>Version:{versionData?.data?.current_version}</DateWrap>
      </UserDetailsLogoBox>
    </UserDetailsMainWrap>
  );
};

export default Firsttable;

const UserDetailsMainWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "stretch",
  marginBottom: "15px",
  "@media (max-width: 1199px)": {
    flexDirection: "column-reverse",
  },
}));

const UserDetailsBox = styled(Box)(() => ({
  width: "70%",
  background: "#e6e6e6",
  display: "flex",
  flexWrap: "wrap",
  paddingLeft: "0",
  paddingRight: "0",
  border: "1px solid #6f6f6f",
  "@media (max-width: 1199px)": {
    width: "100%",
  },
}));
const UserDetailsLogoBox = styled(Box)(() => ({
  width: "30%",
  textAlign: "center",
  paddingLeft: "15px",
  paddingRight: "15px",
  "@media (max-width: 1199px)": {
    width: "100%",
    paddingBottom: "30px",
  },
}));
const DateWrap = styled(Box)(() => ({
  display: "inline-block",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "1.445",
  color: "#2C2C2E",
  padding: "5px 15px",
  border: "2px solid #6f6f6f",
  background: "#e6e6e6",
  margin: '0 5px',
}));
const UserBoxWrap = styled(Box)(() => ({
  width: "33.33%",
  padding: "5px 15px",
  border: "1px solid #6f6f6f",
  "@media (max-width: 991px)": {
    width: "50%",
  },
  "@media (max-width: 575px)": {
    width: "100%",
  },
}));
const UserBoxFullWrap = styled(Box)(() => ({
  width: "100%",
  padding: "5px 15px",
  border: "1px solid #6f6f6f",
}));
const UserBoxData = styled(Box)(() => ({
  display: "inline-block",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "1.445",
  color: "#2C2C2E",
  wordWrap: "break-word",
  overflowWrap: "break-word",
  whiteSpace: "normal",
  span: {
    fontWeight: "400",
  },
}));
